<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`维保列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #status="params">
        <span class="status status1" v-if="params.params.is_status == 1">车队长审核</span>
        <span class="status status2" v-if="params.params.is_status == 2">机务审核</span>
        <span class="status status3" v-if="params.params.is_status == 3">退回{{ params.params.add_group_id == 5 ? '队长' :
          '司机' }}修改</span>
        <span class="status status4" v-if="params.params.is_status == 4">审核通过</span>
      </template>
      <template #btns="params">
        <Btn v-if="!showEditBtn(params.params)" :config="btns[0]" :data="params.params" />
        <Btn v-if="showEditBtn(params.params)" :config="btns[1]" :data="params.params" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保列表", path: `/fix/list` },
      ],
      formCtrl: [
        {
          label: "维保时间",
          keyName: "rstarttime",
          placeholder: "请选择",
          type: "daterange",
          options: [],
        },
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "维保类型",
          keyName: "articleid",
          placeholder: "请选择维保类型",
          type: "select",
          options: [],
        },
        {
          label: "维保厂家",
          keyName: "maunit",
          placeholder: "请填写维保厂家",
          type: "text",
        },
        {
          ...this.ctrls.license,
        },
        // {
        //   label: "备注",
        //   keyName: "repair",
        //   placeholder: "请填写备注信息",
        //   type: "text",
        // },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "fleet_name", label: "车队长", minwidth: 110 },
        { keyName: "article_name", label: "维保类型", minwidth: 120 },
        { keyName: "maunit", label: "维保厂家", minwidth: 150 },
        { keyName: "rstarttime", label: "维保时间", minwidth: 100 },
        { keyName: "money", label: "维保金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "add_name", label: "填写人", minwidth: 120 },
        { keyName: "is_status", label: "审核状态", slot: 'status' },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns' },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/fix/detail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id, is_status, add_group_id }) => {
            const { user_group_id } = this.user
            let path = '/fix/detail'
            if (
              // 队长
              (user_group_id == 5 && add_group_id == 9 && is_status == 1)
              // 机务
              || (user_group_id == 6 && add_group_id != 6 && is_status == 2)
              // 超管
              // || (user_group_id == 1 && is_status == 4)
            ) {
              path = '/fix/examine'
            }
            this.$router.push({
              path,
              query: {
                mode: 'edit',
                id,
              }
            });
          },
        },
      ],
      getTotalProperty: ['money'],
      fleet: [],
      article: [],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      // console.log('formInline', { ...this.formInline })
      if (['fleet', 'articleid'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    showEditBtn(a) {
      let boo = false
      const { user_group_id } = this.user
      const { is_status, add_group_id } = a
      if (
        // 1 车队长审核，2 机务审核，3 退回修改，4 审核通过
        // 队长
        (user_group_id == 5 && is_status == 1 || (is_status == 3 && add_group_id == user_group_id)) ||
        // 机务
        (user_group_id == 6 && (is_status == 4 && add_group_id == 6 || is_status == 2)) ||
        // 司机只能改自己的单子
        (user_group_id == 9 && is_status == 3 && add_group_id == user_group_id) ||
        // 超管
        (user_group_id == 1 && is_status == 4)
      ) {
        boo = true
      }
      return boo
    },
    addItem() {
      this.$router.push(`/fix/add`);
    },
    getOptions() {
      let url = `${this.baseUrl}/getsearch`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet, article }) => {
        this.formCtrl.map(v => {
          if (v.keyName === 'fleet' && fleet && fleet.length) {
            this.fleet = fleet
            this.setCtrlOption(v, fleet, 'nickname')
          } else if (v.keyName === 'articleid' && article && article.length) {
            this.article = article
            this.setCtrlOption(v, article)
          }
        })
        this.$forceUpdate()
        this.setQueryParams()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setQueryParams() {
      const { fleetname, name, months, monthe } = this.$route.query
      if (fleetname) {
        this.fleet.map(v => {
          console.log({ ...v })
          if (v.nickname == fleetname) {
            this.formInline.fleet = v.id
          }
        })
      }
      if (name) {
        this.article.map(v => {
          // console.log({ ...v })
          if (v.name == name) {
            this.formInline.articleid = v.id
          }
        })
      }
      if (months && monthe) {
        this.formInline.month = [months, monthe]
      }
      if (name || (months && monthe)) {
        this.$nextTick(this.getList)
      }
      // console.log('formInline', { ...this.formInline })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
      this.getList()
    }
  },
  mounted() {
    console.log('formInline', { ...this.formInline })
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table {

  .status {
    color: #ffe100;

    &.status4 {
      color: #98e098;
    }

    &.status3 {
      color: #fd5b5b;
    }
  }
}
</style>
